import * as constants from 'config/constants';
import { useWorkspaceQuery } from 'queries/userAndPermissions';
import { useEffect } from 'react';

export const useFakeAuthentication = () => {
  const workspaceQuery = useWorkspaceQuery({ enabled: true });

  useEffect(() => {
    localStorage.setItem(constants.B2C_LOCAL_STORAGE_EMAIL, 'email@mail.com');
  }, []);

  useEffect(() => {
    if (workspaceQuery.data) {
      if (workspaceQuery.data.length > 0) {
        localStorage.setItem(constants.LOCAL_STORAGE_WORKSPACE_ID, workspaceQuery.data[0].id);
      }
    }
  }, [workspaceQuery.data]);

  useEffect(() => {
    if (workspaceQuery.isError) {
      localStorage.removeItem(constants.LOCAL_STORAGE_WORKSPACE_ID);
    }
  }, [workspaceQuery.isError]);

  return {
    username: 'user',
    isAuthenticated: true,
    isLoading: false,
    error: false,
    login: (email: string) => {
      localStorage.setItem(constants.B2C_LOCAL_STORAGE_EMAIL, email);

      console.log('Fake login executed');
    },
    logout: () => {
      console.log('Fake logout executed');
    },
  };
};
